import React, { Component } from "react";
import classnames from "classnames";

import { remap } from "@formant/ui/utils/remap";

import * as styles from "./PieChart.scss";

export interface IPieChartProps {
    value: number;
    min?: number;
    max?: number;
    size?: number;
    stroke?: number;
    invertedWarning?: boolean;
    label?: string;
    className?: string;
}

const defautSize = 30;
const defautStroke = 3;
const warningThreshold = 0.7;
const errorThreshold = 0.8;
const criticalThreshold = 0.9;

export class PieChart extends Component<IPieChartProps> {
    public render() {
        const { value, invertedWarning, label, className, ...props } =
            this.props;
        const min = this.props.min !== undefined ? this.props.min : 0;
        const max = this.props.max !== undefined ? this.props.max : 100;
        const size =
            this.props.size !== undefined ? this.props.size : defautSize;
        const stroke =
            this.props.stroke !== undefined ? this.props.stroke : defautStroke;
        const r = (size - stroke) / 2;
        const q = 2 * Math.PI * r;
        const strokeDashoffset =
            q -
                (q * (Math.min(Math.max(value, min), max) - min)) /
                    (max - min) || 0;

        const remappedValue = remap(
            value,
            min,
            max,
            invertedWarning ? 1 : 0,
            invertedWarning ? 0 : 1,
        );

        const warning =
            remappedValue >= warningThreshold && remappedValue < errorThreshold;

        const error =
            remappedValue >= errorThreshold &&
            remappedValue < criticalThreshold;

        const critical = remappedValue >= criticalThreshold;

        return (
            <div
                className={classnames(
                    styles["pie-chart"],
                    warning && styles.warning,
                    error && styles.error,
                    critical && styles.critical,
                    className,
                )}
                {...props}
            >
                {label && <div className={styles.label}>{label}</div>}
                <svg width={size} height={size}>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={r}
                        fill="none"
                        strokeWidth={stroke}
                        className={styles.background}
                    />
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={r}
                        fill="none"
                        strokeWidth={stroke}
                        strokeDasharray={q}
                        transform={`rotate(-90,${size / 2},${size / 2})`}
                        className={styles.foreground}
                        style={{ strokeDashoffset }}
                    />
                </svg>
            </div>
        );
    }
}
